module.exports = __webpack_public_path__ + "img/setiabudi-farming-solution.0bca87ec.png";